import React from 'react';

const Footer = () => {
  return (
    <footer className="text-center py-4 bg-gray-100 text-sm text-gray-600">
      &copy; {new Date().getFullYear()} TorkMinds – Task Evaluation System
    </footer>
  );
};

export default Footer;
 
